import * as React from "react";
import { makeStyles, TextField as MaterialTextField } from "@material-ui/core";

const TextField = (props) => {
  const classes = useStyles();
  return <MaterialTextField variant="outlined" {...props} className={classes.input} />;
};

export default TextField;

const useStyles = makeStyles((theme) => ({
  input: {
    borderRadius: 12,
    "& .MuiInputLabel-outlined": {
      color: theme.palette.text.disabled,
      transform: "translate(14px, 21px) scale(1)",
      paddingRight: 22,
      [theme.breakpoints.down("sm")]: {
        transform: "translate(14px, 18px) scale(1)",
      },
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(12px, 10px) scale(0.8)",
      paddingRight: 28,
      zIndex: 3,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      top: 0,
      "& > legend": {
        display: "none",
      },
    },
    "& .MuiOutlinedInput-input:-webkit-autofill": {
      boxShadow: "0 0 0 30px white inset !important",
    },
    "& .MuiInputBase-root": {
      backgroundColor: "white",
      padding: theme.spacing(),
      paddingLeft: 0,
      height: 64,
      [theme.breakpoints.down("sm")]: {
        height: 56,
      },
      borderRadius: 12,
      margin: 0,
      "& div": {
        marginTop: 10,
      },
      "& > input": {
        zIndex: 2,
        fontSize: 16,
        paddingBottom: 0,
        marginLeft: theme.spacing(),
        paddingLeft: 5,
        paddingTop: `${theme.spacing(2)}px !important`,
      },
      "& > textarea": {
        zIndex: 2,
        fontSize: 16,
        paddingBottom: 0,
        marginLeft: theme.spacing(),
        marginTop: theme.spacing(3),
        paddingLeft: 5,
      },
      "&::after": {
        border: "none",
      },
    },
    "& .MuiInputBase-multiline ": {
      height: "unset !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWidth: "0px",
    },
    "& .MuiInputBase-root.Mui-focused": {
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.1)",
      border: `2px solid ${theme.palette.secondary.main}`,
      "& > input": {
        paddingBottom: 0,
      },
    },
  },
}));
